import { useState as _useState$ } from "react";
import { renderReactScope as _renderReactScope$ } from "million/react";
import { For as _For$ } from "million/react";
import { block as _block$ } from "million/react";
import React from 'react';
import { FaLinkedin, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';
import { SlLocationPin } from 'react-icons/sl';
import { BiPhone } from 'react-icons/bi';
import LogoVitrum from '../Imagenes/Logos/LogoVitrum.png';
const M$2 = () => {
  const currentYear = new Date().getFullYear();
  const scrollToSection = sectionId => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/3471331775?text=Hola%20me%20gustaría%20contactarme%20para...", "_blank");
  };
  const handleLinkedinClick = () => {
    window.open("https://www.linkedin.com/company/vitrumsoft/about/?viewAsMember=true", "_blank");
  };
  const handleInstagramClick = () => {
    window.open("https://www.instagram.com/vitrumsoft/", "_blank");
  };
  const navegacion = [{
    nombre: "Inicio",
    id: "inicio"
  }, {
    nombre: "Servicios",
    id: "servicios"
  }, {
    nombre: "Nosotros",
    id: "nosotros"
  }, {
    nombre: "Clientes",
    id: "clientes"
  }, {
    nombre: "Equipo",
    id: "equipo"
  }, {
    nombre: "Contacto",
    id: "contacto"
  }];
  const _portal = _useState$(() => ({
      $: new Array(5)
    }))[0],
    _ = _renderReactScope$(<_For$ each={navegacion}>{(item, index) => _temp({
        item: item,
        index: index,
        navegacion: navegacion,
        scrollToSection: scrollToSection
      })}</_For$>, false, _portal.$, 0, false),
    _2 = _renderReactScope$(<SlLocationPin className="w-5 h-5 text-[#bdff57] flex-shrink-0 mt-0.5" />, false, _portal.$, 1, false),
    _3 = _renderReactScope$(<MdMailOutline className="w-5 h-5 text-[#bdff57] flex-shrink-0" />, false, _portal.$, 2, false),
    _4 = _renderReactScope$(<BiPhone className="w-5 h-5 text-[#bdff57] flex-shrink-0" />, false, _portal.$, 3, false),
    _5 = _renderReactScope$(<FaWhatsapp className="w-5 h-5 text-[#bdff57] flex-shrink-0" />, false, _portal.$, 4, false);
  return <><P$ LogoVitrum={LogoVitrum} _={_} _2={_2} _3={_3} _4={_4} _5={_5} handleWhatsAppClick={handleWhatsAppClick} />{_portal.$.map(p => p.portal)}</>;
};
const P$ = /*million:transform*/_block$(({
  LogoVitrum,
  _,
  _2,
  _3,
  _4,
  _5,
  handleWhatsAppClick
}) => {
  return <footer className="relative bg-[#000000] border-t border-white/5">
            {void 0}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#bdff57]/50 to-transparent" />

            {void 0}
            <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-8">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-8">

                    {void 0}
                    <div className="lg:col-span-1">
                        <img src={LogoVitrum} alt="Vitrum Logo" className="h-12 mb-6" />
                        <p className="text-gray-400 text-sm leading-relaxed mb-6">
                            Transformamos ideas en soluciones digitales. Desarrollamos software a medida que impulsa el crecimiento de tu negocio.
                        </p>
                    </div>

                    {void 0}
                    <div>
                        <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">
                            Navegación
                        </h4>
                        <ul className="space-y-3">
                            {_}
                        </ul>
                    </div>

                    {void 0}
                    <div>
                        <h4 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">
                            Contacto
                        </h4>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3">
                                {_2}
                                <span className="text-gray-400 text-sm">
                                    Rosario, Santa Fe<br />Argentina
                                </span>
                            </li>
                            <li className="flex items-center gap-3">
                                {_3}
                                <a href="mailto:info@vitrumsoft.com" className="text-gray-400 text-sm hover:text-[#bdff57] transition-colors">
                                    info@vitrumsoft.com
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                {_4}
                                <a href="tel:+543471331775" className="text-gray-400 text-sm hover:text-[#bdff57] transition-colors">
                                    +54 3471 331775
                                </a>
                            </li>
                            <li className="flex items-center gap-3">
                                {_5}
                                <button onClick={handleWhatsAppClick} className="text-gray-400 text-sm hover:text-[#bdff57] transition-colors">
                                    Enviar WhatsApp
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                {void 0}
                <div className="my-10 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

                {void 0}
                <div className="flex flex-col md:flex-row justify-around 2xl:justify-between items-center gap-4">
                    <p className="text-gray-500 text-sm">
                        &copy; {2026} Vitrum. Todos los derechos reservados.
                    </p>
                    {void 0}
                    <div className="flex justify-center">
                        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/5">
                            <span className="text-xs text-gray-500">
                                Vitrum, tu socio tecnológico ideal
                            </span>
                        </div>
                    </div>
                </div>


            </div>
        </footer>;
}, {
  svg: false,
  shouldUpdate: (a, b) => a?.LogoVitrum !== b?.LogoVitrum || a?._ !== b?._ || a?._2 !== b?._2 || a?._3 !== b?._3 || a?._4 !== b?._4 || a?._5 !== b?._5 || a?.handleWhatsAppClick !== b?.handleWhatsAppClick
});
const Footer = M$2;
export default Footer;
const callback$ = ({
  item,
  index,
  navegacion,
  scrollToSection
}) => {
  const _6 = () => scrollToSection(item.id),
    _7 = item.nombre;
  return <P$2 index={index} _6={_6} _7={_7} />;
};
const P$2 = /*million:transform*/_block$(({
  index,
  _6,
  _7
}) => {
  return <li key={index}>
                                    <button onClick={_6} className="text-gray-400 hover:text-[#bdff57] transition-colors duration-300 text-sm">
                                        {_7}
                                    </button>
                                </li>;
}, {
  svg: false,
  shouldUpdate: (a, b) => a?.index !== b?.index || a?._6 !== b?._6 || a?._7 !== b?._7
});
callback$.__block_callable__ = true;
const _temp = callback$;